/* IMPORTS
	You can import directly from node_modules here.
*/
import $ from 'jquery';
import '@accessible360/accessible-slick/slick/slick.min';

// Make jQuery globally available
window.$ = $;

// import './libraries/hoverintent.min.js';
// import './libraries/what-input.js';

import FOUC from './components/fouc';
import smoothScroll from './libraries/smooth-scroll';
import linkIconInjector from './components/link-icon-injector';
import oEmbedWrapper from './components/oembed';
// import headerDarkMode from './components/header-darkmode';
import svgEmbedder from './components/svg-embedder';
import searchResults from './components/search-results';

import mainMenuSubMenus from './components/header-submenus';
import mainMenuSearch from './components/header-search';
import mainMenuMobile from './components/header-mobile-menu';
import footerNavigation from 'js/components/footer-navigation';
import homeHeroForm from '../blocks/homepage-hero/js/homepage-hero';
import accordions from './components/accordions';
import getCookie from './components/cookies';
import browseButton from './components/browse-button';
import tabs from '../blocks/tab-block/js/tab-block';
import dropdownMenu from './components/dropdown-menu';
import searchableTable from '../blocks/searchable-table/js/searchable-table';
import relatedPost from '../blocks/related-posts/js/acf-related-post';
import photoGallery from '../blocks/photo-gallery/js/photo-gallery';
import filteredContentList from '../blocks/filtered-content-listing/js/ajax-block';
import peopleList from '../blocks/people-list/js/people-list';
import authoredSlider from '../blocks/authored-content-slider/js/authored-content-slider';
import featuredResources from '../blocks/featured-resources/js/featured-resources';
import feedback from '../blocks/feedback/js/feedback';
import membersLoginMenu from './components/members-login-menu';
import headerScroll from './components/header-scroll';
import membership from '../blocks/membership/js/membership';
import sponsors from '../blocks/sponsors/js/sponsors';
import searchWindow from './components/search-window';
import searchToggle from './components/search-toggle';
import pdfEmbed from '../blocks/pdf-embed/js/pdf-embed';
import featuredUpdates from '../blocks/featured-updates/js/featured-updates';
import quoteSlider from '../blocks/quote-slider/js/quote-slider';
import userWayClick from './plugins/userway';

// Shared variables and functions
export const menuState = {
	debug: false,   // Set to true to enable debug console logs
	openMenu: null, // "mobile" or "search"
	closeCurrentMenu: () => {},
};

export const restoreTabIndexToToggleButton = () => {
	if (menuState.debug) {
		console.log('Restoring tabindex to toggle button');
	}
};

export const setTabIndexToFirstTappableElement = () => {
	if (menuState.debug) {
		console.log('Setting tabindex to first tappable element');
	}
};

// Loads before the DOMContentLoaded
window.addEventListener('load', () => {
	FOUC();
});

// When the DOM finishes loading
document.addEventListener('DOMContentLoaded', () => {
	$('body').addClass('document-ready');

	// Higher priority first, lower priority later
	mainMenuSubMenus(menuState);
	mainMenuSearch(menuState);
	mainMenuMobile(
		menuState,
		restoreTabIndexToToggleButton,
		setTabIndexToFirstTappableElement
	);
	// headerDarkMode();
	footerNavigation();
	headerScroll();
	membersLoginMenu();
	searchWindow();
	searchToggle();
	getCookie();

	// Medium priority
	homeHeroForm();
	linkIconInjector();
	smoothScroll();
	oEmbedWrapper();
	svgEmbedder();
	searchResults();

	// Lower Priority
	accordions();
	dropdownMenu();
	tabs(true);
	browseButton();
	searchableTable();
	relatedPost();
	photoGallery();
	// filteredContentList();
	authoredSlider();
	featuredResources();
	peopleList();
	feedback();
	membership();
	sponsors();
	pdfEmbed();
	featuredUpdates();
	userWayClick();
	quoteSlider();
});
